import {registerAnchor} from "@/g6-canvas/shape/anchor";
import {registerEdge} from "@/g6-canvas/shape/edge";
import {registerActivity} from "@/g6-canvas/shape/activity";

export function registerShape(G6) {
    registerAnchor(G6)
    registerEdge(G6)
    registerActivity(G6)
}